import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Link } from "react-router-dom";

const Cart = () => {
  const { cart, clearCart, removeItem, updateQuantity } = useContext(CartContext);

  // Calcula el precio descontado para un producto
  const getDiscountedPrice = (product) => {
    if (product.discount > 0) {
      return product.price * (1 - product.discount / 100);
    }
    return product.price;
  };

  // Calcular total de la compra
  const total = cart.reduce(
    (acc, item) => acc + getDiscountedPrice(item) * item.quantity,
    0
  );

  // Calcular ahorro total: (precio original - precio con descuento) * cantidad
  const totalSavings = cart.reduce((acc, item) => {
    if (item.discount > 0) {
      const savings = (item.price - getDiscountedPrice(item)) * item.quantity;
      return acc + savings;
    }
    return acc;
  }, 0);

  // Funciones para aumentar y disminuir cantidad
  const handleDecrease = (productId, currentQuantity) => {
    if (currentQuantity > 1) {
      updateQuantity(productId, currentQuantity - 1);
    }
  };

  const handleIncrease = (productId, currentQuantity) => {
    updateQuantity(productId, currentQuantity + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <h1 className="text-3xl font-bold text-center mb-6">Tu Carrito de Compras 🛒</h1>
      {cart.length === 0 ? (
        <p className="text-center text-gray-600">No hay productos en el carrito.</p>
      ) : (
        <>
          <div className="space-y-4 max-w-4xl mx-auto">
            {cart.map((item) => {
              const discountedPrice = getDiscountedPrice(item);

              return (
                <div
                  key={item._id}
                  className="bg-white p-4 rounded-lg shadow flex flex-col sm:flex-row items-center sm:items-start justify-between"
                >
                  {/* Sección izquierda: imagen y texto */}
                  <div className="flex items-center sm:items-start sm:flex-row">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-20 h-20 object-cover rounded mr-4"
                    />
                    <div className="flex flex-col">
                      <h2 className="font-bold text-lg">{item.title}</h2>
                      {item.discount > 0 ? (
                        <p className="text-sm text-gray-600">
                          <span className="line-through text-red-500 mr-1">${item.price}</span>
                          <span className="font-bold">${discountedPrice.toFixed(2)}</span>
                        </p>
                      ) : (
                        <p className="text-sm text-gray-600">${item.price}</p>
                      )}
                      {/* Control de cantidad (bajo la imagen y el título) */}
                      <div className="flex items-center mt-2">
                        <button
                          onClick={() => handleDecrease(item._id, item.quantity)}
                          className="bg-gray-200 px-2 py-1 rounded-l"
                        >
                          -
                        </button>
                        <span className="px-3 py-1 border-y border-gray-200 text-center">
                          {item.quantity}
                        </span>
                        <button
                          onClick={() => handleIncrease(item._id, item.quantity)}
                          className="bg-gray-200 px-2 py-1 rounded-r"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Sección derecha: total y botón eliminar */}
                  <div className="flex flex-col items-end mt-4 sm:mt-0">
                    {/* Total individual (bajo el precio individual) */}
                    <p className="text-sm text-gray-600">
                      Total: ${(discountedPrice * item.quantity).toFixed(2)}
                    </p>
                    <button
                      onClick={() => removeItem(item._id)}
                      className="text-red-500 text-sm hover:underline mt-2"
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
          {/* Sección de totales */}
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between mt-6 border-t pt-4">
            <div className="text-xl font-bold">
              Total: ${total.toFixed(2)}
            </div>
            <div className="text-lg font-bold text-green-600">
              Ahorro total: ${totalSavings.toFixed(2)}
            </div>
            <div className="flex space-x-4 mt-4 sm:mt-0">
              <button
                onClick={clearCart}
                className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300"
              >
                Vaciar Carrito
              </button>
              <Link
                to="/checkout"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Continuar con la compra🐾
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
